import React from "react";
import AuthService from "../services/AuthService";
import RestService from "../services/RestService";
import { getClientConfig } from "../services/clientConfig";

export default function useApi() {
  const cfg = getClientConfig();
  return React.useMemo(
    () => ({
      main: new RestService({
        rootUrl: `${cfg.mainApiUrl}/v1/${AuthService.profile.siteId}`,
        tokenAccessor: () => AuthService.legacyToken.token,
        includeSiteId: false
      }),
      admin: new RestService({
        rootUrl: cfg.adminApiUrl,
        tokenAccessor: () => AuthService.token.token,
        handleLogoutOn401: true,
      }),
      // NEVER add handleLogoutOn401 here. Field-mapper endpoints (NetSuite/HubSpot/Salesforce/
      // Dynamics/etc.) return 401 to mean "the VENDOR's OAuth grant expired, reconnect that
      // integration" (see IntegrationAuthFailureClassifier, velaro-messaging), not "the Velaro
      // session expired." Arming handleLogoutOn401 here would turn a dead NetSuite token into a
      // forced admin logout. See docs/architecture/postmortems.md -> "NetSuite Field Mapper 500
      // On Expired OAuth Grant" (2026-08-23).
      messaging: new RestService({
        rootUrl: cfg.messagingApiUrl,
        tokenAccessor: () => AuthService.token.token
      }),
      contactcenter: new RestService({
        rootUrl: cfg.contactCenterApiUrl,
        tokenAccessor: () => AuthService.token.token
      })
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [] // config is populated before mount — stable for the lifetime of the app
  );
}
